import React from 'react';

function Wrench(){
    return(
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" id="icon" viewBox="0 0 124.6 122" >
<g id="wrench">
	<path className="st6" d="M15.4,116c0,0-14.5-1.8-13.3-17.4c0,0,1.6-5.5,4.8-8l46.2-40.9c0,0,2.2-4.3,1.7-12.1c0,0-2.8-14.9,8-25.7
		c0,0,11.2-13.5,32.1-7.1l-6.7,6.6"/>
	<path className="st6" d="M22.3,114.6c0,0,7.4-4.4,23.2-23.7l23.4-25.5c0,0,0.5-2.7,11.5-2.1c0,0,19.8,2.8,30.3-13.5
		c0,0,8.3-16.3,2.3-25.9L98.5,37.5L84.2,35l-3.9-14.5l2.3-3"/>
	<path className="st7" d="M16.5,100l-5.4,5.4c-0.4,0.4-0.4,1.2,0,1.6l0.6,0.6c0.4,0.4,1.2,0.4,1.6,0l5.4-5.4c0.4-0.4,0.4-1.2,0-1.6
		l-0.6-0.6C17.7,99.6,17,99.6,16.5,100z"/>
	<path className="st7" d="M64.6,39.8L63.8,39c-0.6-0.6-0.7-1.5-0.1-2.2l2.2-2.3c0.6-0.6,1.5-0.7,2.2-0.1l0.9,0.8
		c0.6,0.6,0.7,1.5,0.1,2.2l-2.2,2.3C66.2,40.4,65.2,40.4,64.6,39.8z"/>
	<path className="st7" d="M69.7,44.4l-0.9-0.8c-0.6-0.6-0.7-1.5-0.1-2.2l2.2-2.3c0.6-0.6,1.5-0.7,2.2-0.1l0.9,0.8
		c0.6,0.6,0.7,1.5,0.1,2.2l-2.2,2.3C71.3,45,70.3,45,69.7,44.4z"/>
	<path className="st7" d="M75,49.6l-0.9-0.8c-0.6-0.6-0.7-1.5-0.1-2.2l2.2-2.3c0.6-0.6,1.5-0.7,2.2-0.1l0.9,0.8c0.6,0.6,0.7,1.5,0.1,2.2
		l-2.2,2.3C76.6,50.2,75.6,50.2,75,49.6z"/>
	<path className="st7" d="M79.9,54.4L79,53.6c-0.6-0.6-0.7-1.5-0.1-2.2l2.2-2.3c0.6-0.6,1.5-0.7,2.2-0.1l0.9,0.8
		c0.6,0.6,0.7,1.5,0.1,2.2L82,54.4C81.5,55,80.5,55,79.9,54.4z"/>
	<circle className="st8" cx="71.9" cy="96.5" r="6.9"/>
	<circle className="st8" cx="109" cy="81.9" r="6.9"/>
	<circle className="st9" cx="72.1" cy="96.7" r="3.4"/>
	<circle className="st9" cx="109.1" cy="82" r="3.4"/>
	<polygon className="st6" points="59.2,89.5 59,103.2 71.3,110.9 84.2,104.4 85,103.7 84.8,88.8 71.8,81.6 	"/>
	<polygon className="st6" points="96.3,74.9 108.7,67 122.1,74.7 122.2,88.8 109,96.7 96.3,89.4 	"/>
</g>
</svg>

    )
}

export default Wrench;